// ── La lecture du flux de l'assistant dans le navigateur : une ligne NDJSON par evenement (chantier ASI) ──
import type { AssistantEvent } from '@/lib/services/assistant.service';

export function createNdjsonParser() {
  let buffer = '';
  const parse = (line: string): AssistantEvent[] => {
    if (!line.trim()) return [];
    try {
      return [JSON.parse(line) as AssistantEvent];
    } catch {
      return [];
    }
  };
  return {
    push(chunk: string): AssistantEvent[] {
      buffer += chunk;
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';
      return lines.flatMap(parse);
    },
    end(): AssistantEvent[] {
      const rest = buffer;
      buffer = '';
      return parse(rest);
    },
  };
}

/** Lit le corps d'une reponse jusqu'au bout, et passe chaque evenement dans l'ordre */
export async function readAssistantStream(body: ReadableStream<Uint8Array>, onEvent: (e: AssistantEvent) => void) {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  const parser = createNdjsonParser();
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    parser.push(decoder.decode(value, { stream: true })).forEach(onEvent);
  }
  parser.push(decoder.decode()).forEach(onEvent);
  parser.end().forEach(onEvent);
}
